import React from "react";
import useReproductiveProtocolContext from "../../hooks/useReproductiveProtocolContext";
import { ReproductiveProtocolContextProvider } from "../../contexts/reproductiveProtocolContext";
import { useSelector } from "react-redux";

import { Col, Icon, Row } from "antd";
import { CardCustom, Title } from "./styles";
import ButtonStandard from "../../components/utils/button";
import ReproductiveProtocolForm from "./form";
import ReproductiveProtocolTable from "./table";

// import { Container } from './styles';

const ReproductiveProtocolLayout = () => {
  const { translation } = useSelector((state) => state.app);
  const { fetchData, openDrawer } = useReproductiveProtocolContext();
  return (
    <CardCustom>
      <Row className="rowHeader" justify="space-between">
        <Col span={8}>
          <Title>{translation.reproductiveProtocol.title}</Title>
        </Col>
        <Col span={16}>
          <Row type="flex" justify="end" gutter={8}>
            <Col>
              <ButtonStandard
                buttonType="typeWithoutBackground"
                onClick={fetchData}
              >
                <Icon type="reload" />
              </ButtonStandard>
            </Col>
            <Col>
              <ButtonStandard buttonType="addNew" onClick={() => openDrawer()}>
                {translation.reproductiveProtocol.buttonNew}
              </ButtonStandard>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row type="flex">
        <Col span={24}>
          <ReproductiveProtocolTable />
        </Col>
      </Row>
    </CardCustom>
  );
};

const ReproductiveProtocol = () => {
  return (
    <ReproductiveProtocolContextProvider>
      <ReproductiveProtocolLayout />
      <ReproductiveProtocolForm />
    </ReproductiveProtocolContextProvider>
  );
};

export default ReproductiveProtocol;
